import React from 'react';
import { Grid } from 'fw/forms';
import { Button } from 'fw/components';
import API from 'fw/system/API';
import * as APIModules from 'modules/app/API';
import { Col, Row } from 'react-bootstrap';
import AssociatedUserInfo from './AssociatedUserInfo';
import * as FormManager from 'fw/forms/form/FormManager'

const columns = [
    { key: 'firstName', name: 'First Name', width: 200 },
    { key: 'lastName', name: 'Last Name', width: 200 },
    { key: 'email', name: 'Email' }
];

class AssociatedUserTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
            rows: [],
            userId: null,
            dba: null,
            dbaNames: null,
            name: null,
            location: null
        };
    }

    componentDidMount() {
        this.search();
    }

    resetUser = () => {
        this.setState({ userId: null });
    }

    search = (callback) => {
        let me = this;

        var rq = {
            certificationKey: this.props.selectedId
        };

        new API().post(APIModules.Biz.url('/vobSetup/getAssociatedUsers'), rq,
            {
                success: (r) => {
                    let dba = r.data.dba;
                    let dbaNames = r.data.dbaNames;
                    let name = r.data.name;
                    let location = r.data.location;
                    let rows = r.data.items;

                    // Store search results
                    this.setState({ 
                        rows: rows,
                        dba: dba,
                        dbaNames: dbaNames,
                        name: name,
                        location: location
                    }, me.resetUser());
                }
            });
    }

    goToUserDetails = () => {
        setTimeout(() => {
            window.scrollTo({
                behavior: "smooth",
                top: this._userDetail.offsetTop
            });
        }, 200);
    }

    onEditUser = (userId) => {
        FormManager.checkUnsavedChanges(() => {
            this.setState({ userId: userId }, () => { this.goToUserDetails() });
        });
    }

    handleUserUpdate = () => {
        this.search();
    }

    handleUserCancel = () => {
        this.resetUser();
    }

    handleAddUser = () => {
        this.setState({ userId: 0 }, () => { this.goToUserDetails() });
    }

    render() {
        return (
            <React.Fragment>
                <Row>
                    <Col md={12}>
                        <h3 className="inline">
                            {this.state.name} &nbsp;
                            <small>
                                {this.state.location}
                            </small>
                            <Button id="btnAddNew" bsStyle="success" className="pull-right" style={{ marginRight: 0, marginTop: "5px" }}
                                onClick={this.handleAddUser} disabled={this.state.userId === 0}>Add new user</Button>
                        </h3>
                        <div style={{ marginTop: "5px" }}>
                            Doing Business As: <b>{this.state.dba ? this.state.dbaNames : " - "}</b>
                        </div>
                    </Col>
                </Row>
                <br />
                <hr />
                <Row>
                    <Col md={12}>
                        <h3>
                            User Details - <small>These are the users associated with the Company</small>
                        </h3>
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col md={12}>
                        <Grid
                            ref={(c) => { this._grid = c }}
                            columns={columns}
                            items={this.state.rows}
                            height={250}
                            className="table-condensed"
                            rowKey="userId"
                            onChange={this.onEditUser}
                            name="default" />
                    </Col>
                </Row>
                {this.state.userId !== null &&
                    <React.Fragment>
                        <Row>
                            <Col md={12}>
                                <AssociatedUserInfo
                                    certificationKey={this.props.selectedId}
                                    userId={this.state.userId}
                                    onUpdate={this.handleUserUpdate}
                                    onCancel={this.handleUserCancel}
                                />
                            </Col>
                        </Row>
                        <div ref={(c) => { this._userDetail = c }}>
                        </div>
                    </React.Fragment>
                }

            </React.Fragment>
        )
    }
}

export default AssociatedUserTab;



// WEBPACK FOOTER //
// ./src/areas/companyManagement/manageCompany/associatedUsers/AssociatedUserTab.js